<template lang='pug'>
v-container.pa-0(fluid)
  v-app-bar(app, flat, dense, fixed, dark, color="primary")
    v-app-bar-nav-icon(@click="toggleDrawerMenu")
    v-toolbar-title.subtitle-1 ワークスペース {{ $store.getters['Login/additional'] }}
    v-spacer
    v-tooltip(bottom)
      template(v-slot:activator="{ on: tooltip }")
        v-menu(
          v-model="filterMenu",
          :nudge-width="300",
          :max-width="500",
          offset-y,
          :close-on-content-click="false"
        )
          template(v-slot:activator="{ on: menu }")
            v-btn.mr-0(icon, v-on="{ ...tooltip, ...menu }")
              v-icon mdi-filter-variant
          v-card
            v-list
              .subtitle-1.title.ml-2 フィルター
              v-list-item
                v-list-item-action
                  v-switch(v-model="displayAll", color="primary")
                v-list-item-title 全メンバーを表示する
              v-divider(v-if="!displayAll")
              v-list-item(v-if="!displayAll")
                v-list-item-title.subtitle-2 表示グループ
              v-list-item(v-if="!displayAll")
                v-card(flat)
                  v-chip.ma-1(
                    v-for="tag in selectedTags",
                    :key="tag.memberTagId",
                    @click="removeTag(tag)",
                    close,
                    @click:close="removeTag(tag)",
                    color="primary",
                    outlined
                  ) {{ tag.name }}
              v-list-item(v-if="!displayAll")
                v-list-item-title.subtitle-2 表示しないグループ[緑はパーソナルタグ]
              v-list-item(v-if="!displayAll")
                v-card(flat)
                  v-chip.ma-1(
                    v-for="tag in unselectedTags",
                    :key="tag.memberTagId",
                    @click="addTag(tag)",
                    :color="tag.appUserId == null ? 'black' : 'green'",
                    outlined
                  ) {{ tag.name }}
              v-list-item(v-if="!displayAll")
                v-list-item-action
                  v-switch(v-model="displayGrouping", color="primary")
                v-list-item-title グループ化して表示
              v-divider
              v-list-item
                v-list-item-action
                  v-switch(v-model="displaySortByActiveTime", color="primary")
                v-list-item-title アクティブ時間で並べ替え
              v-list-item
                v-list-item-action
                  v-switch(v-model="displayOnlyActive", color="primary")
                v-list-item-title アクティブな人だけ表示

      span フィルター
    v-tooltip(bottom)
      template(v-slot:activator="{ on }")
        v-btn.mr-0(icon, v-on="on", @click.stop="toggleDrawerRight")
          v-icon mdi-dots-vertical
      span ヒストリー
  v-row.d-flex.flex-column.ma-0
    div(v-for="info in informations", :key="info.informationBoardId")
      v-alert.mb-0(
        dense,
        :color="info.color",
        border="left",
        tile,
        outlined,
        :text="info.url == null || info.url == ''"
      )
        span(v-if="info.url == null || info.url == ''") {{ info.message }}
        a.alert__link(v-else, :href="info.url", target="_blank") {{ info.message }}
  v-row.mr-0.ml-0.pl-4.pr-4.py-2(justify="end")
    v-icon.pr-1(small) account_circle
    .caption 作業中：{{ userCount }}人

  v-container.workspace__wrapper(fluid)
    v-row.d-flex.flex-column(
      v-for="(group, gindex) in activeUserGroups",
      :key="gindex"
    )
      v-divider.mx-3.mb-1(v-if="group.name != null && group.name.length > 0")
      v-row.ma-0.px-3.subtitle-1(
        v-if="group.name != null && group.name.length > 0"
      ) {{ group.name }}
      v-row.pl-4.pr-4(
        :justify="group.name != null && group.name.length > 0 ? 'start' : 'center'"
      )
        v-card.ma-2(
          v-for="(item, index) in group.users",
          :key="item.displayName",
          flat,
          width="120",
          height="174",
          @click="dispDetail(item)"
        )
          v-img.white--text.align-end(
            height="120",
            :src="getImageUrl(item)",
            :class="{ 'display-avatar--inactive': item.status == 'inactive' }"
          )
          .display-name(
            :class="{ 'display-name--active': item.status == 'active', 'display-name--inactive': item.status == 'inactive' }"
          )
            .display-name__wrapper
              .subtitle-2.mb-0.text-center {{ item.displayNameDisp }}
            v-tooltip(bottom)
              template(v-slot:activator="{ on }")
                v-chip.px-2(
                  small,
                  :active="item.statusMessage != null",
                  v-on="on",
                  :class="{ 'comment--active': item.status == 'active', 'comment--inactive': item.status == 'inactive' }"
                )
                  .status-message {{ shortenMessage(item.statusMessage) }}
              span {{ item.statusMessage }}
          button.add-reaction-icon(text, @click="openReaction(item)")
            v-icon mdi-plus
          .status-icon(
            v-show="item.emojiName != null && item.emojiName != \"\""
          )
            v-tooltip(bottom)
              template(v-slot:activator="{ on }")
                .status-icon__emoji(v-html="item.emoji", v-on="on")
              span {{ item.emojiName }}
          .reaction__wrapper.d-flex.flex-row.flex-wrap.align-content-start.flex-wrap
            .reaction__item(
              v-for="emoji in emojisForUser(reactionByPerson, item.displayName)",
              :key="emoji.memberReactionId"
            )
              v-tooltip(top)
                template(v-slot:activator="{ on }")
                  span(v-html="emoji.emoji", v-on="on")
                span {{ emoji.posted }} {{ emoji.fromDisplayName }} {{ emoji.privateMessage }}

    v-tooltip(top)
      template(v-slot:activator="{ on }")
        v-fab-transition
          v-btn.comment-btn(
            fab,
            bottom,
            right,
            large,
            color="primary",
            fixed,
            :class="{ 'comment-btn--dodge': drawerRight }",
            v-on="on",
            @click="openStatusMessage()"
          )
            v-icon(color="white") sms
      span 自由にコメントしてください
    v-btn.change-project-btn.white--text.font-weight-bold(
      rounded,
      bottom,
      right,
      fixed,
      color="blue",
      :class="{ 'change-project-btn--dodge': drawerRight }",
      @click="showChangeProjectDialog = true"
    ) {{ $store.direct.state.Users.currentProject }}
  v-navigation-drawer(
    v-model="drawerRight",
    app,
    right,
    width="400",
    floating,
    mobile-break-point="960",
    color="grey lighten-3"
  )
    template(v-if="flgLog")
      v-row.ma-0.px-4.drawer__close-btn.drawer__header(
        align="center",
        justify="space-between"
      )
        .subtitle-1 ヒストリー
        v-tooltip(bottom)
          template(v-slot:activator="{ on }")
            v-btn.mr-0(icon, large, v-on="on", @click.stop="closeDrawer")
              v-icon close
          span 閉じる
      v-row.mx-0
        v-col.px-4.pt-0
          .body-2.workspace-history(
            v-for="(item, index) in logs",
            :key="index"
          ) 
            span.workspace-history__time {{ item.time }}
            span {{ item.message }}
    template(v-else)
      v-row.ma-0.px-4.drawer__close-btn.drawer__header(
        align="center",
        justify="space-between"
      )
        .d-flex.align-center
          .subtitle-1 メンバーボード
          v-divider.mx-3(vertical)
          .subtitle-1 {{ currentUser.displayName }}
        v-tooltip(bottom)
          template(v-slot:activator="{ on }")
            v-btn.mr-0(icon, large, v-on="on", @click.stop="closeDrawer")
              v-icon close
          span 閉じる
      v-row.mx-0
        v-col.px-4.pt-0
          v-avatar.mr-2.portfolio__avatar(size="80")
            v-img(
              :src="getImageUrl(currentUser)",
              :alt="currentUser.displayName",
              @click="largeProfileImage = true"
            )
          v-avatar.mr-2.portfolio__avatar(
            size="80",
            v-show="currentUser.userFamilyImageId"
          )
            v-img(
              :src="getFamilyImageUrl(currentUser)",
              :alt="currentUser.displayName",
              @click="largeFamilyImage = true",
              :gradient="isPrivacyMode ? 'to top right, rgba(0,0,0,1), rgba(0,0,0,1)' : ''"
            )
          v-avatar.mr-2.portfolio__avatar(
            size="80",
            v-show="currentUser.userImage3Id"
          )
            v-img(
              :src="getImage3Url(currentUser)",
              :alt="currentUser.displayName",
              @click="largeImage3 = true",
              :gradient="isPrivacyMode ? 'to top right, rgba(0,0,0,1), rgba(0,0,0,1)' : ''"
            )
          v-avatar.portfolio__avatar(
            size="80",
            v-show="currentUser.userImage4Id"
          )
            v-img(
              :src="getImage4Url(currentUser)",
              :alt="currentUser.displayName",
              @click="largeImage4 = true",
              :gradient="isPrivacyMode ? 'to top right, rgba(0,0,0,1), rgba(0,0,0,1)' : ''"
            )
          .title.pt-3.pb-1 {{ privacyConverter(currentUser.lastName) }} {{ privacyConverter(currentUser.firstName) }}
          .portfolio.mb-3(v-if="largeProfileImage == true")
            v-img(
              width="368",
              :src="getImageUrl(currentUser)",
              @click="largeProfileImage = false"
            )
            v-tooltip(bottom)
              template(v-slot:activator="{ on }")
                v-btn(
                  fab,
                  color="black",
                  depressed,
                  x-small,
                  v-on="on",
                  @click="largeProfileImage = false"
                )
                  v-icon(color="white") close
              span 閉じる
          .portfolio.mb-3(v-if="largeFamilyImage == true")
            v-img(
              width="368",
              :src="getFamilyImageUrl(currentUser)",
              @click="largeFamilyImage = false",
              :gradient="isPrivacyMode ? 'to top right, rgba(0,0,0,1), rgba(0,0,0,1)' : ''"
            )
            v-tooltip(bottom)
              template(v-slot:activator="{ on }")
                v-btn(
                  fab,
                  color="black",
                  depressed,
                  x-small,
                  v-on="on",
                  @click="largeFamilyImage = false"
                )
                  v-icon(color="white") close
              span 閉じる
          .portfolio.mb-3(v-if="largeImage3 == true")
            v-img(
              width="368",
              :src="getImage3Url(currentUser)",
              @click="largeImage3 = false",
              :gradient="isPrivacyMode ? 'to top right, rgba(0,0,0,1), rgba(0,0,0,1)' : ''"
            )
            v-tooltip(bottom)
              template(v-slot:activator="{ on }")
                v-btn(
                  fab,
                  color="black",
                  depressed,
                  x-small,
                  v-on="on",
                  @click="largeImage3 = false"
                )
                  v-icon(color="white") close
              span 閉じる
          .portfolio.mb-3(v-if="largeImage4 == true")
            v-img(
              width="368",
              :src="getImage4Url(currentUser)",
              @click="largeImage4 = false",
              :gradient="isPrivacyMode ? 'to top right, rgba(0,0,0,1), rgba(0,0,0,1)' : ''"
            )
            v-tooltip(bottom)
              template(v-slot:activator="{ on }")
                v-btn(
                  fab,
                  color="black",
                  depressed,
                  x-small,
                  v-on="on",
                  @click="largeImage4 = false"
                )
                  v-icon(color="white") close
              span 閉じる

          .userdetail__status.mb-3
            .userdetail__status-emoji(
              v-html="recordDetail.emoji",
              v-if="recordDetail.emojiURL == null || recordDetail.emojiURL == ''"
            )
            .userdetail__icon-img
              v-img(
                width="24",
                height="24",
                :src="recordDetail.emojiURL",
                v-if="recordDetail.emojiURL != null && recordDetail.emojiURL != ''"
              )
            .userdetail__status-message.body-2 {{ recordDetail.statusMessage }}

          v-divider.my-3
          .div
            .userdetail__category-name Email
            .body-1
              a(:href="'mailto:' + currentUser.email") {{ privacyConverter(currentUser.email) }}
          v-divider.my-3
          .row.ma-0.mb-4
            .userdetail__contact(
              v-if="currentUser.slackId != null && currentUser.slackId != ''"
            )
              .userdetail__category-name Slack Id
              .body-1 {{ privacyConverter(currentUser.slackId) }}
              v-btn(
                small,
                :href="slackLink()",
                color="primary",
                depressed,
                outlined
              ) Slack DM
            .userdetail__contact(
              v-if="currentUser.telephoneNumber != null && currentUser.telephoneNumber != ''"
            )
              .userdetail__category-name 電話番号
              .body-1 {{ privacyConverter(currentUser.telephoneNumber) }}
              v-btn(
                small,
                :href="'tel:' + currentUser.telephoneNumber",
                color="primary",
                depressed,
                outlined
              ) 電話をかける

          v-divider.my-3(
            v-if="currentUser.familyName1 != null && currentUser.familyName1 != ''"
          )
          .row.ma-0.mb-4(
            v-if="currentUser.familyName1 != null && currentUser.familyName1 != ''"
          )
            .userdetail__family
              .userdetail__category-name 家族 1
              .body-1 {{ privacyConverter(currentUser.familyName1) }}
            .userdetail__family(
              v-if="currentUser.familyName2 != null && currentUser.familyName2 != ''"
            )
              .userdetail__category-name 家族 2
              .body-1 {{ privacyConverter(currentUser.familyName2) }}
          .row.ma-0.mb-4(
            v-if="currentUser.familyName3 != null && currentUser.familyName3 != ''"
          )
            .userdetail__family
              .userdetail__category-name 家族 3
              .body-1 {{ privacyConverter(currentUser.familyName3) }}
            .userdetail__family(
              v-if="currentUser.familyName4 != null && currentUser.familyName4 != ''"
            )
              .userdetail__category-name 家族 4
              .body-1 {{ privacyConverter(currentUser.familyName4) }}
          .row.ma-0.mb-4(
            v-if="currentUser.familyName5 != null && currentUser.familyName5 != ''"
          )
            .userdetail__family
              .userdetail__category-name 家族 5
              .body-1 {{ privacyConverter(currentUser.familyName5) }}

          v-expansion-panels.mb-3(flat, tile)
            v-expansion-panel
              v-expansion-panel-header.userdetail__table-title.subtitle-2 最近の活動
              v-divider
              v-expansion-panel-content
                v-row.ma-3
                  v-simple-table.userdetail__table(
                    dense,
                    v-if="userHistories.length > 0"
                  )
                    template(v-slot:default)
                      thead
                        tr
                          th.text-left.pl-1 開始
                          th.text-left 終了
                          th.text-left 休憩(分)
                          th.text-left 合計
                      tbody
                        tr(
                          v-for="(item, index) in userHistories",
                          :key="item.timesheetId"
                        )
                          td.pl-1 {{ item.startedShort }}
                          td {{ item.endedShort }}
                          td {{ item.breakTimespan }}
                          td {{ item.total }}
                  v-simple-table.userdetail__table(
                    v-if="currentUser != null && currentUser.comments != null && currentUser.comments.length > 0",
                    dense
                  )
                    template(v-slot:default)
                      thead
                        tr
                          th.text-left.pl-1(colspan="4") コメント
                      tbody
                        tr(
                          v-for="comment in currentUser.comments",
                          :key="comment.statusMessageId"
                        )
                          td.status-updated.pl-1 {{ comment.updated }}
                          td.status-updated__comment(colspan="3")
                            span(v-html="comment.emoji")
                            span {{ comment.message }}

          v-expansion-panels.mb-3(accordion, flat, tile)
            v-expansion-panel
              v-expansion-panel-header.userdetail__table-title.subtitle-2 予定
              v-divider
              v-expansion-panel-content
                v-row.ma-3
                  v-simple-table.userdetail__table.mb-3(dense)
                    template(v-slot:default)
                      thead
                        tr
                          th.text-left.userdetail__table-row1.pl-1 {{ firstWeekName }}
                          th.text-left 実績
                      tbody
                        tr(
                          v-for="(item, index) in currentUser.firstPlannings",
                          :key="item.date"
                        )
                          td(
                            :class="{ userdetail__holiday: item.workTypeName === '休日', userdetail__hikado: item.workTypeName === '非稼働' }"
                          )
                            span.pl-1.mr-1 {{ item.dateDisp }}
                            span.mr-1(
                              v-if="currentUser.ignoreTimesheet != true"
                            ) {{ item.workTypeName }}
                              br
                              span.pl-1(v-show="item.dateName") {{ item.dateName }}
                          td(
                            :class="{ userdetail__holiday: item.workTypeName === '休日', userdetail__hikado: item.workTypeName === '非稼働' }"
                          )
                            span {{ item.plan }}
                  v-simple-table.userdetail__table(dense)
                    template(v-slot:default)
                      thead
                        tr
                          th.text-left.userdetail__table-row1.pl-1 {{ secondWeekName }}
                          th.text-left 予定
                      tbody
                        tr(
                          v-for="(item, index) in currentUser.firstPlannings",
                          :key="item.date"
                        )
                          td(
                            :class="{ userdetail__holiday: currentUser.secondPlannings[index].workTypeName === '休日', userdetail__hikado: currentUser.secondPlannings[index].workTypeName === '非稼働' }"
                          )
                            span.pl-1.mr-1 {{ currentUser.secondPlannings[index] == null ? '' : currentUser.secondPlannings[index].dateDisp }}
                            span.mr-1(
                              v-if="currentUser.ignoreTimesheet != true"
                            ) {{ currentUser.secondPlannings[index] == null ? '' : currentUser.secondPlannings[index].workTypeName }}
                              br
                              span.pl-1(
                                v-show="currentUser.secondPlannings[index].dateName"
                              ) {{ currentUser.secondPlannings[index] == null ? '' : currentUser.secondPlannings[index].dateName }}
                          td(
                            :class="{ userdetail__holiday: currentUser.secondPlannings[index].workTypeName === '休日', userdetail__hikado: currentUser.secondPlannings[index].workTypeName === '非稼働' }"
                          )
                            span {{ currentUser.secondPlannings[index] == null ? '' : currentUser.secondPlannings[index].plan }}

          v-expansion-panels.bottom-item(accordion, flat, tile)
            v-expansion-panel
              v-expansion-panel-header.userdetail__table-title.subtitle-2 週報 投稿日:{{ currentUser.weeklyPostedDate }}
              v-divider
              v-expansion-panel-content(v-if="currentUser.weekly")
                v-row.userdetail__weekly.ma-3 
                  .body-2 {{ currentUser.weekly }}

  v-dialog(v-model="dialogReaction", max-width="400")
    v-card
      v-row.mx-0.px-6.pt-6.d-flex.flex-column
        v-card-title.body-2.px-0.pt-0.pb-4 {{ reactionTargetUser.displayName }}さんにリアクションを送ります。
        v-row.mx-0.mb-2.d-flex.flex-column(
          v-if="$vuetify.breakpoint.width < 420",
          justify="center"
        )
          emoji-picker(
            @select="selectedReaction",
            v-if="selectedEmoji == null",
            :custom="emojiList",
            :emojiSize="18"
          )
          .emoji-check(v-html="emoji", v-if="emoji != null")
          v-text-field(
            label="プライベートコメント",
            v-if="emoji != null",
            v-model="privateMessage",
            hide-details="auto"
          )
        v-row.mx-0.mb-2.d-flex.flex-column(v-else, justify="center")
          emoji-picker(
            @select="selectedReaction",
            v-if="selectedEmoji == null",
            :custom="emojiList"
          )
          .emoji-check(v-html="emoji", v-if="emoji != null")
          v-text-field(
            label="プライベートコメント",
            v-if="emoji != null",
            v-model="privateMessage",
            hide-details="auto"
          )
      v-card-actions.px-6
        v-spacer
        v-btn(text, @click="dialogReaction = false") キャンセル
        v-btn(text, @click="sendReaction", :disabled="inProcess") OK

  v-dialog(v-model="dialogStatusMessage", max-width="400")
    v-card
      v-row.mx-0.px-6.pt-6.d-flex.flex-column
        v-card-title.body-2.px-0.pt-0.pb-4 コメントを設定します。
        v-row.mx-0.mb-2.d-flex.flex-column(
          v-if="$vuetify.breakpoint.width < 420",
          justify="center"
        )
          emoji-picker(
            @select="selectedReaction",
            v-if="selectedEmoji == null && dialogStatusMessage",
            :custom="emojiList",
            :emojiSize="18"
          )
          .emoji-check(v-html="emoji", v-if="emoji != null")
          v-text-field(
            label="コメント",
            v-model="statusMessage",
            hide-details="auto"
          )
        v-row.mx-0.mb-2.d-flex.flex-column(v-else, justify="center")
          emoji-picker(
            @select="selectedReaction",
            v-if="selectedEmoji == null && dialogStatusMessage",
            :custom="emojiList"
          )
          .emoji-check(v-html="emoji", v-if="emoji != null")
          v-text-field(
            label="コメント",
            v-model="statusMessage",
            hide-details="auto"
          )
      v-card-actions.px-6
        v-spacer
        v-btn(text, @click="dialogStatusMessage = false") キャンセル
        v-btn(text, @click="sendStatusMessage", :disabled="inProcess") OK
  change-project-dialog(
    v-if="showChangeProjectDialog",
    :showDialog.sync="showChangeProjectDialog",
    @close="showChangeProjectDialog = false"
  )
  v-overlay(:value="progressOverlay || progressInit")
    v-progress-circular(indeterminate, size="64")
</template>

<script>
import basic from "@/components/mixins/basic";
import moment from "moment";
import { Picker } from "emoji-mart-vue";
import EmojiConvertor from "emoji-js";
import ChangeProjectDialog from "@/components/ChangeProjectDialog";
export default {
  mixins: [basic],
  components: {
    "emoji-picker": Picker,
    "change-project-dialog": ChangeProjectDialog,
  },
  computed: {
    canStart: {
      get() {
        if (this.timesheets == null) return false;
        var toReturn = true;
        this.timesheets.forEach((ts) => {
          if (ts.ended == null || ts.ended == "") {
            toReturn = false;
          }
        });
        return toReturn;
      },
    },
    canEnd: {
      get() {
        if (this.timesheets == null) return false;
        if (this.timesheets.length == 0) return false;
        var toReturn = false;
        this.timesheets.forEach((ts) => {
          if (ts.ended == null || ts.ended == "") {
            toReturn = true;
          }
        });
        return toReturn;
      },
    },
    activeUsers() {
      return this.$store.state.Users.activeUsers;
    },
    reactionByPerson() {
      return this.$store.state.Users.reactionByPerson;
    },
    timesheets() {
      return this.$store.state.Timesheet.timesheets;
    },
    userHistory() {
      return this.$store.state.Users.userHistory.length > 10
        ? this.$store.state.Users.userHistory.slice(0, 10)
        : this.$store.state.Users.userHistory;
    },
    logs: {
      get() {
        return this.$store.state.Users.logs;
      },
    },
    userCount() {
      var totalUsers = this.activeUsers.reduce((total, current) => {
        return total + (current.status == "active" ? 1 : 0);
      }, 0);
      this.$emit("show", totalUsers);
      return totalUsers;
    },
    progressInit() {
      return this.activeUsers.length == 0 && this.logs.length == 0;
    },
    activeUserGroups() {
      return this.$store.getters["Home/activeUserGroups"];
    },
    firstWeekName() {
      return moment().isoWeekday() > 4 ? "今週" : "先週";
    },
    emojiList() {
      return this.$store.state.Masters.emojiList;
    },
    secondWeekName() {
      return moment().isoWeekday() > 4 ? "来週" : "今週";
    },
    drawer() {
      return this.$store.state.Menu.drawer;
    },
    informations() {
      return this.$store.state.Users.informations == null
        ? []
        : this.$store.state.Users.informations;
    },
    displayName: {
      get() {
        return this.$store.getters["Login/displayName"];
      },
    },
    displayAll: {
      get() {
        return this.$store.state.Home.displayAll;
      },
      set(value) {
        this.$store.commit("Home/SET_VALUE", {
          name: "displayAll",
          value: value,
        });
      },
    },
    displayOnlyActive: {
      get() {
        return this.$store.state.Home.displayOnlyActive;
      },
      set(value) {
        this.$store.commit("Home/SET_VALUE", {
          name: "displayOnlyActive",
          value: value,
        });
      },
    },
    displaySortByActiveTime: {
      get() {
        return this.$store.state.Home.displaySortByActiveTime;
      },
      set(value) {
        this.$store.commit("Home/SET_VALUE", {
          name: "displaySortByActiveTime",
          value: value,
        });
      },
    },
    displayGrouping: {
      get() {
        return this.$store.state.Home.displayGrouping;
      },
      set(value) {
        this.$store.commit("Home/SET_VALUE", {
          name: "displayGrouping",
          value: value,
        });
      },
    },
    tags: {
      get() {
        return this.$store.state.Home.tags;
      },
      set(value) {
        this.$store.commit("Home/SET_VALUE", { name: "tags", value: value });
      },
    },
    selectedTags: {
      get() {
        return this.$store.state.Home.selectedTags;
      },
      set(value) {
        this.$store.commit("Home/SET_VALUE", {
          name: "selectedTags",
          value: value,
        });
      },
    },
    unselectedTags: {
      get() {
        return this.$store.state.Home.unselectedTags;
      },
      set(value) {
        this.$store.commit("Home/SET_VALUE", {
          name: "unselectedTags",
          value: value,
        });
      },
    },
    isPrivacyMode: {
      get() {
        return this.$store.direct.state.Home.isPrivacyMode;
      },
    },
  },
  data() {
    return {
      dialogDetail: false,
      recordDetail: {},
      currentUser: {},
      userHistories: [],
      largeFamilyImage: false,
      largeImage3: false,
      largeImage4: false,
      largeProfileImage: false,
      dialogReaction: false,
      selectedEmoji: null,
      reactionTargetUser: {},
      emojiConverter: null,
      emoji: null,
      privateMessage: null,
      drawerRight: false,
      flgLog: null,
      statusMessage: null,
      dialogStatusMessage: false,
      inProcess: false,
      filterMenu: false,
      progressOverlay: false,
      showChangeProjectDialog: false,
    };
  },
  mounted() {},
  methods: {
    async masterReady() {
      this.emojiConverter = new EmojiConvertor();
      this.emojiConverter.replace_mode = "img";
      this.emojiConverter.allow_native = false;
      this.emojiConverter.img_sets.apple.path =
        "https://cdn.jsdelivr.net/npm/emoji-datasource-apple@5.0.1/img/apple/64/";
      this.tags = await this.$store.dispatch("MemberTags/listAll", 3);
      this.$store.direct.dispatch.PrivacyWord.listAll();
      await this.search();
    },
    async search() {},
    getImageUrl(item) {
      if (item.userImageId == null) {
        return this.site.deployFolder + "/noimage.png";
      }
      var result = this.$store.getters["Users/userImageUrl"] + item.userImageId;
      return result;
    },
    getFamilyImageUrl(item) {
      if (item.userFamilyImageId == null) {
        return this.site.deployFolder + "/noimage.png";
      }
      var result =
        this.$store.getters["Users/userImageUrl"] + item.userFamilyImageId;
      return result;
    },
    getImage3Url(item) {
      if (item.userImage3Id == null) {
        return this.site.deployFolder + "/noimage.png";
      }
      var result =
        this.$store.getters["Users/userImageUrl"] + item.userImage3Id;
      return result;
    },
    getImage4Url(item) {
      if (item.userImage4Id == null) {
        return this.site.deployFolder + "/noimage.png";
      }
      var result =
        this.$store.getters["Users/userImageUrl"] + item.userImage4Id;
      return result;
    },
    async startSession() {
      await this.$store.dispatch("Timesheet/startSession", this.offsetMin);
      await this.search();
    },
    async endSession() {
      await this.$store.dispatch("Timesheet/endSession", this.offsetMin);
      await this.search();
    },
    async dispDetail(item) {
      if (this.dialogReaction) {
        return;
      }
      this.currentUser = await this.$store.dispatch(
        "Users/userWithDisplayName",
        item.displayName
      );
      this.userHistories = await this.$store.dispatch(
        "Timesheet/getUserHistory",
        item.displayName
      );
      this.largeFamilyImage = false;
      this.largeProfileImage = false;
      this.flgLog = false;
      this.drawerRight = true;
      this.recordDetail = item;
    },
    openSlack() {
      window.open(
        "slack://user?team=T02EJK5TR&id=" + this.currentUser.slackId,
        "_blank"
      );
    },
    slackLink() {
      return "slack://user?team=T02EJK5TR&id=" + this.currentUser.slackId;
    },
    shortenMessage(message) {
      if (message == null || message == "") {
        return null;
      }
      if (message.length > 8) {
        return message.substring(0, 8) + "…";
      }
      return message;
    },
    openReaction(item) {
      this.progressOverlay = true;
      this.$nextTick(() => {
        setTimeout(() => {
          this.dialogReaction = true;
          this.selectedEmoji = null;
          this.emoji = null;
          this.privateMessage = "";
          this.reactionTargetUser = item;
        }, 100);
        setTimeout(() => {
          this.progressOverlay = false;
        }, 1000);
      });
    },
    selectedReaction(emoji) {
      this.selectedEmoji = emoji;
      if (this.selectedEmoji.custom) {
        this.emoji =
          "<img width='24' height='24' src='" + emoji.imageUrl + "'/>";
      } else {
        this.emoji = this.emojiConverter.replace_colons(emoji.colons);
      }
    },
    async sendReaction() {
      if (this.inProcess) {
        return;
      }
      this.inProcess = true;
      try {
        if (this.selectedEmoji == null) {
          this.dispError("絵文字を選択してください");
          return;
        }
        await this.$store.dispatch("Users/sendReaction", {
          toDisplayName: this.reactionTargetUser.displayName,
          emojiName: this.selectedEmoji.colons,
          privateMessage: this.privateMessage,
        });
        this.dispSuccess("送信しました。");
        this.dialogReaction = false;
      } catch {
        this.dispError("コメント送信に失敗しました。");
      }
      this.inProcess = false;
    },
    addTag(item) {
      this.selectedTags.push(item);
      this.selectedTags = this.selectedTags;
      this.unselectedTags = this.unselectedTags.filter(
        (element) => element != item
      );
    },
    removeTag(item) {
      this.unselectedTags.push(item);
      this.unselectedTags = this.unselectedTags;
      this.selectedTags = this.selectedTags.filter(
        (element) => element != item
      );
    },
    emojisForUser(item, displayName) {
      var user = item.find((element) => element.toDisplayName == displayName);
      if (user == null) {
        return null;
      }
      return user.emojis;
    },
    toggleDrawerMenu() {
      this.$emit("toggle");
    },
    toggleDrawerRight() {
      if (this.drawerRight && this.flgLog) {
        this.drawerRight = false;
        this.flgLog = false;
      } else if (this.drawerRight && !this.flgLog) {
        this.flgLog = true;
      } else {
        this.drawerRight = true;
        this.flgLog = true;
      }
    },
    privacyConverter(text) {
      if (text == null) return "";
      if (this.isPrivacyMode) {
        var len = text.length;
        var t = "";
        for (var i = 0; i < len; i++) {
          t += "○";
        }
        return t;
      }
      return text;
    },
    closeDrawer() {
      this.drawerRight = false;
    },
    openStatusMessage() {
      this.progressOverlay = true;
      this.$nextTick(() => {
        setTimeout(() => {
          this.statusMessage = "";
          this.selectedEmoji = null;
          this.emoji = null;
          this.dialogStatusMessage = true;
        }, 100);
        setTimeout(() => {
          this.progressOverlay = false;
        }, 1000);
      });
    },
    async sendStatusMessage() {
      if (this.inProcess) {
        return;
      }
      this.inProcess = true;
      try {
        await this.$store.dispatch("Users/sendStatusMessage", {
          emojiName:
            this.selectedEmoji == null ? "" : this.selectedEmoji.colons,
          statusMessage: this.statusMessage,
        });
        this.dispSuccess("コメントを送りました。");
        this.dialogStatusMessage = false;
      } catch {
        this.dispError("コメント送信に失敗しました。");
      }
      this.inProcess = false;
    },
  },
};
</script>

<style lang='scss'>
@import "@/scss/variables.scss";
.workspace {
  &__wrapper {
    padding-bottom: 6rem !important;
  }
}
.comment-btn {
  z-index: 999 !important;
  transition: transform 0.4s ease-out;
  &--dodge {
    transform: translateX(-416px);
  }
}
.change-project-btn {
  z-index: 999 !important;
  transition: transform 0.4s ease-out;
  transform: translate(-80px, -10px);
  &--dodge {
    transform: translate(-496px, -10px);
  }
}
.alert {
  &__link {
    text-decoration: none;
    line-height: 0.875rem;
    &:after {
      content: "launch";
      font-family: "Material Icons";
      font-size: 1.25rem;
      vertical-align: -4px;
      padding-left: 0.2rem;
    }
  }
}
.display-avatar {
  &--inactive {
    -webkit-filter: grayscale(1) opacity(0.5);
    filter: grayscale(1) opacity(0.5);
  }
}
.display-name {
  &--active {
    border-top: 3px solid;
    border-color: $green-accent-3;
  }
  &--inactive {
    border-top: 3px solid;
    border-color: #c9c9c9;
  }
  &__wrapper {
    margin-bottom: 2px;
    background-color: $grey-lighten-3;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}
.status-icon {
  position: absolute;
  top: 95px;
  left: 92px;
  height: 30px;
  width: 30px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.2);
  border-radius: 4px !important;
  &__emoji {
    z-index: 1;
    display: flex;
    align-items: center;
    .emoji-sizer {
      width: 1.4rem;
      height: 1.4rem;
    }
  }
}
.comment {
  &--active {
    background-color: $comment !important;
    &:after {
      content: "";
      display: inline-block;
      position: absolute;
      z-index: 0;
      top: -12px;
      left: 10px;
      margin-left: -0px;
      border: 5px solid transparent;
      border-top: 8px solid $comment;
      transform: rotate(180deg);
    }
    &:hover {
      &:after {
        border-top: 8px solid #a8e200;
      }
    }
  }
  &--inactive {
    background-color: $grey-lighten-1 !important;
    &:after {
      content: "";
      display: inline-block;
      position: absolute;
      z-index: 0;
      top: -12px;
      left: 10px;
      margin-left: -0px;
      border: 5px solid transparent;
      border-top: 8px solid $grey-lighten-1;
      transform: rotate(180deg);
    }
  }
}
// .privacy_photo {
//   .v-image__image {
//     filter: grayscale(1) opacity(.5) blur(50);
//   }
// }
.drawer {
  &__header {
    background-color: $grey-lighten-3;
  }
  &__close-btn {
    height: 48px;
  }
}
.workspace-history {
  &__time {
    padding-right: 1rem;
  }
  text-indent: -3.25rem;
  padding-left: 3.25rem;
  margin-bottom: 0.25rem;
  line-height: 1.25rem !important;
}
.reaction {
  &__wrapper {
    position: absolute;
    top: -2px;
    left: -2px;
    height: 124px;
    width: 124px;
    text-align: center;
    vertical-align: middle;
  }
  &__item {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 23px;
    width: 23px;
    background-color: rgba(255, 255, 255, 0.8) !important;
    border: 1px solid $grey-lighten-3;
    border-radius: 4px;
    overflow: hidden;
    span {
      display: block;
    }
    img {
      display: block;
    }
  }
}
.add-reaction-icon {
  position: absolute;
  top: -8px;
  left: 108px;
  height: 20px;
  width: 20px;
  background-color: rgb(255, 255, 255) !important;
  vertical-align: middle;
  text-align: center;
  border-color: lightgray;
  border-style: solid;
  border-width: 1px;
  border-radius: 10px;
  z-index: 1;
  i {
    position: absolute !important;
    top: 0px;
    left: 0px;
    height: 18px;
    width: 18px;
    font-size: 12px !important;
  }
}
.portfolio {
  position: relative;
  &__avatar {
    cursor: pointer;
  }
  button {
    position: absolute;
    top: 4px;
    right: 4px;
    z-index: 1;
  }
}
.userdetail {
  &__status {
    display: flex;
    align-items: center;
  }
  &__status-message {
    font-size: 1rem;
  }
  &__status-emoji {
    display: flex;
    align-items: center;
    .emoji-sizer {
      width: 1.2rem;
      height: 1.2rem;
    }
  }
  &__table {
    border-collapse: collapse;
    width: 100%;
    td {
      padding: 0 !important;
      line-height: 1.25rem;
    }
    thead {
      background: $primary;
      th {
        padding: 0 !important;
        color: white !important;
      }
    }
  }
  &__category-name {
    font-size: 0.6875rem;
    color: gray;
  }
  &__contact,
  &__family {
    width: 48%;
    &:first-child {
      margin-right: 4%;
    }
    .v-btn {
      width: 100%;
    }
  }
  &__table-row1 {
    width: 42%;
  }
  &__hikado {
    background-color: $grey-lighten-2;
  }
  &__holiday {
    background-color: $red-lighten-5;
  }
  &__weekly {
    white-space: pre-wrap;
    word-wrap: break-word;
  }
}
.v-data-table.userdetail__table th {
  padding-top: 5px;
  height: 1.25rem;
  border: none !important;
}
.v-expansion-panel-header.userdetail__table-title,
.v-expansion-panel-header.userdetail__table-title.v-expansion-panel-header--active {
  padding: 0.75rem 0.75rem;
  min-height: inherit;
}
.status-updated {
  min-width: 100px;
  &__comment {
    img {
      margin-left: 0.1rem;
      vertical-align: -0.1rem;
      width: 0.875rem;
      height: 0.875rem;
    }
    .emoji-sizer {
      width: 0.875rem;
      height: 0.875rem;
      vertical-align: -0.1rem;
    }
  }
}
.alert__link {
  color: #ababab;
}
.status-message {
	font-size: 0.6rem;
}
</style>